module.exports = __webpack_public_path__ + "img/img_family_04.d86d963e.svg";